import dayjs from 'dayjs'

const format = 'HH:mm'

type BranchSchedule = {
  work_hour_start?: string
  work_hour_end?: string
  is_work_24_7?: boolean
}

export const isBranchOffHours = (branch?: BranchSchedule | null) => {
  if (!branch || branch.is_work_24_7) return false
  if (!branch.work_hour_start || !branch.work_hour_end) return false
  return !isWorkingHour(branch.work_hour_start, branch.work_hour_end)
}

// Get branch schedule status
export const isWorkingHour = (start?: string, end?: string) => {
  const currentTime = dayjs()

  if (start && end) {
    const workHourStart = dayjs(start, format, true)
    const workHourEnd = dayjs(end, format, true)

    if (start === '00:00' && end === '23:59') {
      return true
    }

    if (workHourEnd.isBefore(workHourStart)) {
      if (
        currentTime.isAfter(workHourStart) ||
        currentTime.isBefore(workHourEnd)
      ) {
        return true
      }
    } else {
      if (
        currentTime.isAfter(workHourStart) &&
        currentTime.isBefore(workHourEnd)
      ) {
        return true
      }
    }

    return false
  }

  return true
}
